
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
// Components
import LayoutSignUpPublic from '@/components/layouts/LayoutSignUpPublic';
import SignUpForm from '@/components/pages/signup/createAccount/SignUpForm';
import Icon from '@/components/base/Icon';
const SignUpAccount = () => {
    const { t } = useTranslation('commons');
    const [isWithEmail, setIsWithEmail] = useState(false);
    return (<LayoutSignUpPublic titleLocale={!isWithEmail ? 'title' : 'with_email_title'} subTitleLocale={!isWithEmail ? 'subtitle' : null} headerChildren={isWithEmail ? (<button className="absolute -top-7 left-0 flex items-center text-xs text-icoGray-500" onClick={() => {
                setIsWithEmail(false);
            }}>
                        <Icon icon="chevron-left" className="mr-1.5 text-icoGray-400"/>
                        {t('back')}
                    </button>) : null} displayFooter={!isWithEmail}>
            <SignUpForm isWithEmail={isWithEmail} setIsWithEmail={setIsWithEmail}/>
        </LayoutSignUpPublic>);
};
export default SignUpAccount;

    async function __Next_Translate__getStaticProps__19a7ca6721f__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signup/account',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19a7ca6721f__ as getStaticProps }
  